// routes to exclude
export const processViewerAccessRoutes = [ 'profile/partner', 'audits', 'profile/my-account', 'provision' ];

// routes exception
export const expressionExcludeRoutes = ['/(provision\/[0-9]{1,})/'];
